module.exports = __webpack_public_path__ + "static/hero-main-7cbaf0a436b6fd3666df274886e98e8f.svg";